import * as React from 'react'
import { formatDistanceToNow, parseISO } from 'date-fns'
import Image from 'next/image'

import { ObituaryMemoryComment as IObituaryMemoryComment, VisitorUser } from '../../types'
import LikePopover from '../popovers/LikePopover'
import styles from './styles.module.scss'

interface Props {
  comment: IObituaryMemoryComment
  hasReaction: boolean
  onLike: (memoryID: number, newUser?: VisitorUser) => Promise<void>
  visitorUser: VisitorUser
}

const ObituaryMemoryComment: React.FC<Props> = ({ comment, hasReaction, onLike, visitorUser }) => {
  const [isPopoverActive, setIsPopoverActive] = React.useState(false)
  const likeButtonRef = React.useRef<HTMLDivElement>()
  const togglePopper = (): void => setIsPopoverActive(!isPopoverActive)
  const _onLike = async (): Promise<void> => {
    visitorUser.email ? onLike(comment.id) : togglePopper()
  }

  return (
    <>
      <div className={styles.obituaryMemoryComment}>
        <div className={styles.obituaryMemoryTopRow}>
          <p className={styles.obituaryMemoryCommentAuthor}>
            {comment.visitor_user.name}

            <span className={styles.timeAgo}>
              {formatDistanceToNow(parseISO(comment.recorded_at))} ago
            </span>
          </p>

          <div className={styles.likeBtnWrapper}>
            <button className={styles.likeBtn} onClick={_onLike} type="button">
              <div id={`like-comment-btn-${comment.id}`} ref={likeButtonRef}>
                <Image
                  alt="heart"
                  height={18}
                  layout="fixed"
                  src={hasReaction ? '/heart-active.svg' : '/heart-inactive.svg'}
                  width={20}
                />
              </div>

              <span className={styles.likeCount}>{comment.like_count}</span>
            </button>
          </div>
        </div>

        <p className={styles.obituaryMemoryContent}>{comment.content}</p>
      </div>

      <LikePopover
        active={isPopoverActive}
        onFormSubmit={async (values) => {
          try {
            await onLike(comment.id, values)

            setIsPopoverActive(false)
          } catch {
            return
          }
        }}
        toggleActive={togglePopper}
        triggerElement={likeButtonRef.current}
      />
    </>
  )
}

export default ObituaryMemoryComment
